import {IDotRezSessionTimerModel} from "./dot-rez-session-timer.interface";

export class VoidDotRezSessionTimer implements IDotRezSessionTimerModel {
    dispose(): void {
    }

    refresh(): void {
    }

}
